import graduationImg from '../assets/images/achievements/graduation.jpeg';
import githubRankImg from '../assets/images/achievements/github-rank.jpeg';
import microverseAwardImg from '../assets/images/achievements/microverse-award.jpeg';
import microverseCertImg from '../assets/images/achievements/microverse-certificate.png';
import wizardReplyImg from '../assets/images/achievements/wizardreply.png';

const achievements = [
  {
    img: wizardReplyImg,
    title: 'Built & Launched WizardReply',
    date: '2025',
    description:
      'Dove into the Plasmo framework and built WizardReply, a Chrome extension that uses AI to auto-generate email replies quickly and effortlessly.',
  },
  {
    img: githubRankImg,
    title: 'Ranked #1 on GitHub Contributions',
    date: '2023',
    description:
      'Ranked first on GitHub contributions in Egypt with 2,887 contributions in one year.',
  },
  {
    img: microverseAwardImg,
    title: 'Microverse Code Review Quality Award',
    date: '2023',
    description:
      'Recognized by Microverse as one of the developers who scored the highest in quality code reviews, after performing 500+ reviews for over 100 junior developers.',
  },
  {
    img: microverseCertImg,
    title: 'Microverse Full Stack Certification',
    date: '2022',
    description:
      'Completed the remote Full Stack Web Development program at Microverse — 1300+ hours mastering algorithms, data structures, and full-stack development with Ruby, Rails, JavaScript, React, and Redux.',
  },
  {
    img: graduationImg,
    title: 'Graduated Top of My Class',
    date: '2021',
    description:
      'Graduated from the Faculty of Computers and Informatics (Computer Science) at Suez Canal University — ranked 8th in the department, with an A+ graduation project.',
  },
];

export default achievements;
